import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import DogDisplay from './DogDisplay';

function DogProfile() {
  const { dogId } = useParams();
  const [dog, setDog] = useState(null);
  const [message, setMessage] = useState('');
  const [playerId, setPlayerId] = useState(null);
  const [titleDefinitions, setTitleDefinitions] = useState([]);
  const [collapsed, setCollapsed] = useState({
    titles: true,
    health: true,
    pedigree: true,
    offspring: true,
    showRecord: true,
    affiliate: true,
  });
  const [showForm, setShowForm] = useState(false);
  const [formType, setFormType] = useState('conformation');
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [formData, setFormData] = useState({
    showName: '',
    result: '',
    awardPoints: 0,
    qualifyingScore: false,
    iconUrl: '',
    resultUrl: '',
    artworkLink: '',
    _id: null,
  });
  const [filters, setFilters] = useState({
    sport: 'All',
    highestLevelOnly: false,
  });
  const [conformationPage, setConformationPage] = useState(1);
  const [sportingPage, setSportingPage] = useState(1);
  const [showAllConformation, setShowAllConformation] = useState(false);
  const [showAllSporting, setShowAllSporting] = useState(false);
  const recordsPerPage = 6;

  // Background system state
  const [selectedBackgroundUrl, setSelectedBackgroundUrl] = useState('');
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [scale, setScale] = useState(1);
  const [failedImages] = useState(new Set());
  const [availableBackgrounds, setAvailableBackgrounds] = useState([
    {
      id: 'free1',
      url: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e278b58f-e271-405b-8060-c4679e13d416/djax4s9-dd642d53-d79e-4adc-bba7-fd93365d376c.png/v1/fill/w_894,h_894,q_70,strp/greenpatch_bg_by_dogfanciersguild_djax4s9-pre.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTEzMCIsInBhdGgiOiJcL2ZcL2UyNzhiNThmLWUyNzEtNDA1Yi04MDYwLWM0Njc5ZTEzZDQxNlwvZGpheDRzOS1kZDY0MmQ1My1kNzllLTRhZGMtYmJhNy1mZDkzMzY1ZDM3NmMucG5nIiwid2lkdGgiOiI8PTExMzAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.nCwZKP3oUFEf7MIicZUd6QDj6rpeH56AC0A9EqeYr_U',
      name: 'Green Patch',
    },
    {
      id: 'free2',
      url: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e278b58f-e271-405b-8060-c4679e13d416/djax4sm-bd720196-1fe3-4b72-868c-7516470f74ab.png/v1/fill/w_894,h_894,q_70,strp/ball_yard_by_dogfanciersguild_djax4sm-pre.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTI1MCIsInBhdGgiOiJcL2ZcL2UyNzhiNThmLWUyNzEtNDA1Yi04MDYwLWM0Njc5ZTEzZDQxNlwvZGpheDRzbS1iZDcyMDE5Ni0xZmUzLTRiNzItODY4Yy03NTE2NDcwZjc0YWIucG5nIiwid2lkdGgiOiI8PTEyNTAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.SZzxXPXhyaKnng3WqlOM9r9z2Sr8BkIbhzSd-tWqrTg',
      name: 'Ball Yard',
    },
    {
      id: 'free3',
      url: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e278b58f-e271-405b-8060-c4679e13d416/djax514-2e3f5872-3a2a-4fdb-b4b1-acb0fc62c074.png/v1/fill/w_894,h_894/corn_field_fence_by_dogfanciersguild_djax514-pre.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTEzMCIsInBhdGgiOiJcL2ZcL2UyNzhiNThmLWUyNzEtNDA1Yi04MDYwLWM0Njc5ZTEzZDQxNlwvZGpheDUxNC0yZTNmNTg3Mi0zYTJhLTRmZGItYjRiMS1hY2IwZmM2MmMwNzQucG5nIiwid2lkdGgiOiI8PTExMzAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.i9aJ6BFFgqbgM8vihlz58lc5LWX0i5iB5ow2TlZWtkM',
      name: 'Corn Fence Field',
    },
    {
      id: 'free4',
      url: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e278b58f-e271-405b-8060-c4679e13d416/djax50p-5b7b6d9e-046b-46c1-9056-a984f575e651.png/v1/fill/w_894,h_894,q_70,strp/cone_flags_by_dogfanciersguild_djax50p-pre.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTAwIiwicGF0aCI6IlwvZlwvZTI3OGI1OGYtZTI3MS00MDViLTgwNjAtYzQ2NzllMTNkNDE2XC9kamF4NTBwLTViN2I2ZDllLTA0NmItNDZjMS05MDU2LWE5ODRmNTc1ZTY1MS5wbmciLCJ3aWR0aCI6Ijw9OTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.w4-b4y7yV881Erh4rfZQcN3uhSKISsWr2ZqvkjIb0xs',
      name: 'Cone Flags',
    },
  ]);

  const fallbackBackground = availableBackgrounds[0].url;

  const [showAffiliateForm, setShowAffiliateForm] = useState(false);
  const [affiliateFormData, setAffiliateFormData] = useState({
  titleName: '',
  proofLink: '',
});


  useEffect(() => {
    const storedPlayerId = localStorage.getItem('playerId');
    if (storedPlayerId) setPlayerId(storedPlayerId);
    else setMessage('Please log in to view this page.');
  }, []);

  useEffect(() => {
    if (!playerId) return;

    const fetchDog = async () => {
      try {
        console.log(`Fetching dog data for dogId: ${dogId}`);
        const res = await fetch(`${API_BASE_URL}/dog/${dogId}`, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          throw new Error(errorData.error || `HTTP error! Status: ${res.status}`);
        }
        const dog = await res.json();
        if (!dog?.dogId || !dog.artUrl) {
          throw new Error('Invalid dog data');
        }
        const validatedDog = {
          ...dog,
          registeredName: dog.registeredName || 'Unknown Dog',
          kennelInfo: dog.kennelInfo || {},
          earnedTitles: dog.earnedTitles || [],
          showRecords: dog.showRecords || [],
          position: dog.position || { x: 0, y: 0 },
          scale: dog.scale || 1,
          backgroundUrl: dog.backgroundUrl || fallbackBackground,
        };
        setDog(validatedDog);
        console.log('Setting selectedBackgroundUrl:', validatedDog.backgroundUrl);
        setSelectedBackgroundUrl(validatedDog.backgroundUrl);
        setPosition(validatedDog.position);
        setScale(validatedDog.scale);
        setMessage('');
        // Removed automatic save to avoid unnecessary requests
      } catch (err) {
        console.error('Fetch error:', err);
        setMessage(
          err.message.includes('404')
            ? `Dog with ID ${dogId} not found`
            : `Failed to fetch dog: ${err.message}`
        );
        setDog(null);
      }
    };

    const fetchTitleDefinitions = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/title-definitions`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        if (!res.ok) throw new Error('Fetch failed');
        setTitleDefinitions(await res.json());
      } catch (error) {
        console.error('Title definitions error:', error);
        setMessage('Error fetching title definitions: ' + error.message);
      }
    };

    fetchDog();
    fetchTitleDefinitions();
  }, [dogId, playerId, fallbackBackground]);

  useEffect(() => {
    console.log('Kennel Info in useEffect:', dog?.kennelInfo);
    if (dog?.kennelInfo) {
      const kennelBackgrounds = [];
      if (dog.kennelInfo.artUrl && typeof dog.kennelInfo.artUrl === 'string') {
        console.log('Adding kennel artUrl:', dog.kennelInfo.artUrl);
        kennelBackgrounds.push({
          id: 'kennel-art',
          url: dog.kennelInfo.artUrl,
          name: `${dog.kennelInfo.kennelName} Kennel Background`,
        });
      } else {
        console.log('No valid kennel artUrl found');
      }
      if (dog.kennelInfo.backgrounds && Array.isArray(dog.kennelInfo.backgrounds)) {
        console.log('Adding kennel backgrounds:', dog.kennelInfo.backgrounds);
        kennelBackgrounds.push(
          ...dog.kennelInfo.backgrounds.map(bg => ({
            id: bg.id,
            url: bg.url,
            name: bg.name,
          }))
        );
      }
      setAvailableBackgrounds(prev => [
        ...prev.filter(bg => !bg.id.startsWith('kennel')),
        ...kennelBackgrounds,
      ]);
    }
  }, [dog]);

  const saveChanges = async () => {
    if (!playerId || !dog) {
      setMessage('Please log in to save changes.');
      return;
    }
    try {
      // Robust URL cleaning
      let cleanBackgroundUrl = selectedBackgroundUrl;
      if (!cleanBackgroundUrl.startsWith('https://')) {
        cleanBackgroundUrl = `https://${cleanBackgroundUrl.split('https://').pop()}`;
      }
      if (cleanBackgroundUrl.includes('https://https://')) {
        cleanBackgroundUrl = cleanBackgroundUrl.split('https://').slice(-1)[0];
        cleanBackgroundUrl = `https://${cleanBackgroundUrl}`;
      }
      
      console.log('Saving changes:', { dogId: dog.dogId, backgroundUrl: cleanBackgroundUrl, position, scale });
      const res = await fetch(`${API_BASE_URL}/dogs/${dog.dogId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          playerId,
          backgroundUrl: cleanBackgroundUrl,
          position,
          scale,
        }),
      });
      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || 'Failed to save changes');
      }
      const updatedDog = await res.json();
      console.log('Save response:', updatedDog);
      if (updatedDog.dog.backgroundUrl !== cleanBackgroundUrl) {
        console.warn('Backend did not update backgroundUrl correctly:', updatedDog.dog.backgroundUrl);
        setMessage('Warning: Background may not have saved correctly.');
      }
      setDog(prev => ({
        ...prev,
        backgroundUrl: cleanBackgroundUrl,
        position,
        scale,
      }));
      setMessage('Changes saved successfully!');
    } catch (err) {
      console.error('Save error:', err);
      setMessage(`Error saving changes: ${err.message}`);
    }
  };

  const toggleCollapse = (section) => {
    setCollapsed(prev => {
      const newCollapsed = { ...prev, [section]: !prev[section] };
      if (section === 'showRecord' && prev[section] === false) {
        setConformationPage(1);
        setSportingPage(1);
        setShowAllConformation(false);
        setShowAllSporting(false);
      }
      return newCollapsed;
    });
  };

  const submitImageUpdate = async () => {
    const newImageUrl = prompt('Enter new image URL:');
    if (!newImageUrl) return;

    try {
      const res = await fetch(`${API_BASE_URL}/submit-update`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({ playerId, dogId: dog.dogId, field: 'artUrl', newValue: newImageUrl }),
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setMessage(data.message);
    } catch (error) {
      setMessage('Failed to submit update: ' + error.message);
    }
  };

  const updateCallName = async () => {
    if (!playerId || !dog) {
      setMessage('Please log in to update call name.');
      return;
    }
    const newCallName = prompt('Enter new call name:', dog.callName);
    if (!newCallName || newCallName === dog.callName) return;

    try {
      const res = await fetch(`${API_BASE_URL}/dog/${dog.dogId}/callname`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({ playerId, callName: newCallName }),
      });
      const rawResponse = await res.text();
      if (!res.ok) {
        let errorMessage = `Server error: ${res.status} ${res.statusText}`;
        try {
          const errorData = JSON.parse(rawResponse);
          errorMessage = errorData.message || errorMessage;
        } catch {
          errorMessage = `Server returned non-JSON response: ${rawResponse}`;
        }
        throw new Error(errorMessage);
      }
      const data = JSON.parse(rawResponse);
      setDog(data.dog);
      setMessage(data.message);
    } catch (error) {
      setMessage(`Failed to update call name: ${error.message}. Try endpoint /dogs/${dog.dogId} with PATCH method.`);
    }
  };

  const PedigreeEntry = ({ info, label, indent = 0 }) => {
    const dashCount = indent === 0 ? 0 : (indent === 1 ? 8 : 15);
    const prefix = '-'.repeat(dashCount);
    const displayName = info?.dogId ? (
      <Link to={`/dog/${info.dogId}`}>{info.registeredName}</Link>
    ) : (
      <span>{info?.registeredName || 'Unknown'}</span>
    );
    return (
      <p style={{ margin: 0 }}>
        {indent ? ' '.repeat(indent * 25) : ''}{prefix}{label}: {displayName}
      </p>
    );
  };

  const addCustomShowRecord = (type = 'conformation') => {
    setFormType(type);
    setFormData({
      showName: '',
      result: '',
      awardPoints: 0,
      qualifyingScore: false,
      iconUrl: '',
      resultUrl: '',
      artworkLink: '',
      _id: null,
    });
    setShowForm(true);
  };

  const editCustomShowRecord = (record, type = 'conformation') => {
    if (record.source !== 'Player') return;
    if (record.validated) {
      setMessage('Cannot edit validated records.');
      return;
    }
    setFormType(type);
    setFormData({
      showName: record.showName,
      result: record.result,
      awardPoints: record.awardPoints || 0,
      qualifyingScore: type === 'sporting' ? record.qualifyingScore : false,
      iconUrl: (record.iconUrl && record.iconUrl[0]) || '',
      resultUrl: record.resultUrl || '',
      artworkLink: record.artworkLink || '',
      _id: record._id,
    });
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { showName, result, awardPoints, qualifyingScore, iconUrl, resultUrl, artworkLink } = formData;
    if (!showName || !result) {
      setMessage('Show name and result are required.');
      return;
    }

    const endpoint = formType === 'conformation' ? 'show-record' : 'sporting-record';
    try {
      const res = await fetch(`${API_BASE_URL}/dog/${dog.dogId}/${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          playerId,
          showName,
          result,
          awardPoints,
          qualifyingScore: formType === 'sporting' ? qualifyingScore : undefined,
          source: 'Player',
          iconUrl: iconUrl ? [iconUrl] : [],
          resultUrl: resultUrl || null,
          artworkLink: artworkLink || null,
          validated: false,
        }),
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setDog(data.dog);
      setMessage(`${formType === 'conformation' ? 'Conformation' : 'Sporting'} record submitted for admin validation`);
      setShowForm(false);
    } catch (error) {
      setMessage(`Failed to add ${formType} record: ` + error.message);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const { showName, result, awardPoints, qualifyingScore, iconUrl, resultUrl, artworkLink, _id } = formData;

    const endpoint = formType === 'conformation' ? 'show-record' : 'sporting-record';
    try {
      const res = await fetch(`${API_BASE_URL}/dog/${dog.dogId}/${endpoint}/${_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          playerId,
          showName,
          result,
          awardPoints,
          qualifyingScore: formType === 'sporting' ? qualifyingScore : undefined,
          source: 'Player',
          iconUrl: iconUrl ? [iconUrl] : [],
          resultUrl: resultUrl || null,
          artworkLink: artworkLink || null,
          validated: false,
        }),
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setDog(data.dog);
      setMessage(`${formType === 'conformation' ? 'Conformation' : 'Sporting'} record updated and submitted for re-validation`);
      setShowForm(false);
      setFormData({ showName: '', result: '', awardPoints: 0, qualifyingScore: false, iconUrl: '', resultUrl: '', artworkLink: '', _id: null });
    } catch (error) {
      setMessage(`Failed to update ${formType} record: ` + error.message);
    }
  };

  const getFilteredTitles = () => {
    if (!dog || !dog.earnedTitles) return [];
    let filteredTitles = dog.earnedTitles.map(title => ({
      ...title,
      definition: titleDefinitions.find(td => td._id.toString() === title.titleId) || {},
    }));

    if (filters.sport !== 'All') {
      filteredTitles = filteredTitles.filter(t => t.definition.sport === filters.sport);
    }

    if (filters.highestLevelOnly) {
      const highestBySport = {};
      filteredTitles.forEach(title => {
        const sport = title.definition.sport || 'Unknown';
        if (!highestBySport[sport] || title.definition.level > highestBySport[sport].definition.level) {
          highestBySport[sport] = title;
        }
      });
      filteredTitles = Object.values(highestBySport);
    }

    return filteredTitles;
  };

  const getDisplayNameWithTitles = () => {
    if (!dog || !dog.earnedTitles) return dog?.registeredName || 'Unknown';

    const bobWins = dog.showRecords?.filter(r => r.result.includes('Best of Breed')).length || 0;
    const prefix = bobWins >= 3 ? 'CH ' : '';

    const highestBySport = {};
    dog.earnedTitles.forEach(title => {
      const titleDef = titleDefinitions.find(td => td._id.toString() === title.titleId) || {};
      const sport = titleDef.sport || 'Unknown';
      const suffix = titleDef.prefixSuffix?.endsWith('#')
        ? titleDef.prefixSuffix.replace('#', title.instance || 1)
        : titleDef.prefixSuffix || '';

      if (!suffix) return;

      const currentInstance = title.instance || 0;
      const storedInstance = highestBySport[sport]?.instance || 0;
      const currentLevel = titleDef.level || 0;
      const storedLevel = highestBySport[sport]?.definition.level || 0;

      if (
        !highestBySport[sport] ||
        currentInstance > storedInstance ||
        (currentInstance === storedInstance && currentLevel > storedLevel)
      ) {
        highestBySport[sport] = { ...title, definition: titleDef, displaySuffix: suffix };
      }
    });

    const suffixes = Object.values(highestBySport)
      .map(title => title.displaySuffix)
      .filter(s => s);

    return `${prefix}${dog.registeredName} ${suffixes.join(' ')}`.trim();
  };

  const getBackgroundUrl = () => {
    if (!selectedBackgroundUrl || failedImages.has(selectedBackgroundUrl)) {
      return fallbackBackground;
    }
    return selectedBackgroundUrl;
  };

  if (!dog) {
    console.log('Render blocked: dog is null');
    return (
      <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center', paddingTop: '60px' }}>
        {message ? (
          <div
            style={{
              backgroundColor: '#ffcccc',
              padding: '10px',
              marginBottom: '20px',
              borderRadius: '5px',
              color: '#333',
              fontWeight: 'bold',
            }}
          >
            {message}
          </div>
        ) : (
          <p>Loading...</p>
        )}
      </div>
    );
  }
  console.log('Rendering DogProfile with dog:', dog);

  const hasHealthTests = (dog.healthTestRecords?.length > 0) || (dog.customHealthTests?.length > 0);
 
  const earnedSports = ['All', ...new Set(
    (dog.earnedTitles || []).map(title => {
      const titleDef = titleDefinitions.find(td => td._id.toString() === title.titleId);
      return titleDef?.sport;
    }).filter(Boolean),
  )];

  const getPaginatedRecords = (records, page) => {
    if (!records || records.length <= recordsPerPage) return records || [];
    const startIndex = (page - 1) * recordsPerPage;
    const endIndex = startIndex + recordsPerPage;
    return records.slice(startIndex, endIndex);
  };

  const totalConformationPages = Math.ceil((dog.showRecords?.length || 0) / recordsPerPage);
  const totalSportingPages = Math.ceil((dog.sportingRecords?.length || 0) / recordsPerPage);

  const renderPagination = (currentPage, totalPages, setPage, showAll, setShowAll) => {
    if (totalPages <= 1) return null;
    return (
      <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
        {!showAll && (
          <>
            <button
              onClick={() => setPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                padding: '5px 10px',
                backgroundColor: currentPage === 1 ? '#ccc' : '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
              }}
            >
              Previous
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(pageNum => (
              <button
                key={pageNum}
                onClick={() => setPage(pageNum)}
                style={{
                  padding: '5px 10px',
                  backgroundColor: currentPage === pageNum ? '#4CAF50' : '#f0f0f0',
                  color: currentPage === pageNum ? 'white' : '#333',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
              >
                {pageNum}
              </button>
            ))}
            <button
              onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              style={{
                padding: '5px 10px',
                backgroundColor: currentPage === totalPages ? '#ccc' : '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
              }}
            >
              Next
            </button>
          </>
        )}
        <button
          onClick={() => {
            setShowAll(!showAll);
            setPage(1);
          }}
          style={{
            padding: '5px 10px',
            backgroundColor: showAll ? '#d9ead3' : '#b6d7a8',
            color: showAll ? '#333' : '#38761d',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          {showAll ? 'Paginate' : 'Show All'}
        </button>
      </div>
    );
  };

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center', paddingTop: '60px' }}>
      {message && (
        <div
          style={{
            backgroundColor: '#90EE90',
            padding: '10px',
            marginBottom: '20px',
            borderRadius: '5px',
            color: 'black',
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          {message}
        </div>
      )}
      {dog.status === 'Deceased' && (
        <div
          style={{
            backgroundColor: '#555',
            color: 'white',
            padding: '15px',
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: '1.2em',
            marginBottom: '20px',
            borderRadius: '5px',
          }}
        >
          Deceased
        </div>
      )}
      {dog.status === 'Hospitalized' && (
  <div
    style={{
      backgroundColor: '#ff4d4d',
      color: 'white',
      padding: '15px',
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '1.2em',
      marginBottom: '20px',
      borderRadius: '5px',
    }}
  >
    Hospitalized
  </div>
)}
      <h1
        style={{
          color: '#1E88E5',
          fontSize: '1.8em',
          margin: '0 0 10px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontWeight: 'bold',
        }}
      >
        {(() => {
          const fullName = getDisplayNameWithTitles();
          const [name, ...titles] = fullName.split(' ');
          return (
            <>
              <span style={{ fontWeight: 'bold' }}>{name}</span>
              {titles.length > 0 && ' ' + titles.join(' ')}
            </>
          );
        })()}
      </h1>
      <p><strong>DFG Official ID Number: </strong>{dog.dogId}</p>
      <DogDisplay
        dog={dog}
        playerId={playerId}
        selectedBackgroundUrl={getBackgroundUrl()}
        setSelectedBackgroundUrl={setSelectedBackgroundUrl}
        position={position}
        setPosition={setPosition}
        scale={scale}
        setScale={setScale}
        availableBackgrounds={availableBackgrounds}
        saveChanges={saveChanges}
        submitImageUpdate={submitImageUpdate}
        updateCallName={updateCallName}
        dogName={dog?.registeredName || 'Unknown Dog'}
      />
      <p><strong>Call Name: </strong> {dog.callName}</p>
      <p><strong>Sex: </strong>{dog.gender} </p>
      <p><strong>Breed: </strong>{dog.breed}</p>
      {dog.kennelInfo && (
        <p>
         <strong>Proudly Presented By: </strong> {dog.kennelInfo.kennelName} 
        </p>
      )}

      <h2
        style={{
          cursor: 'pointer',
          color: collapsed.titles ? '#555' : '#4CAF50',
          marginBottom: '10px',
          transition: 'color 0.3s',
        }}
        onClick={() => toggleCollapse('titles')}
      >
        Earned Titles {collapsed.titles ? '▲' : '▼'}
      </h2>
      {!collapsed.titles && (
        <div
          style={{
            backgroundColor: '#f9f9f9',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            border: '1px solid #d9ead3',
          }}
        >
          <div style={{ marginBottom: '15px' }}>
            <label style={{ marginRight: '10px' }}>Filter by Sport:</label>
            <select
              value={filters.sport}
              onChange={e => setFilters(prev => ({ ...prev, sport: e.target.value }))}
              style={{ padding: '5px', borderRadius: '5px' }}
            >
              {earnedSports.map(sport => (
                <option key={sport} value={sport}>{sport}</option>
              ))}
            </select>
            <label style={{ marginLeft: '20px', marginRight: '10px' }}>
              Highest Level Only:
              <input
                type="checkbox"
                checked={filters.highestLevelOnly}
                onChange={e => setFilters(prev => ({ ...prev, highestLevelOnly: e.target.checked }))}
                style={{ marginLeft: '5px' }}
              />
            </label>
          </div>
          {getFilteredTitles().length > 0 ? (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
              {getFilteredTitles().map((title, idx) => {
                const titleDef = title.definition;
                const displayPrefix = titleDef.prefixSuffix && titleDef.prefixSuffix.endsWith('#')
                  ? titleDef.prefixSuffix.replace('#', title.instance)
                  : titleDef.prefixSuffix || '';
                return (
                  <div
                    key={idx}
                    style={{
                      width: '220px',
                      textAlign: 'center',
                      padding: '10px',
                      backgroundColor: '#fff',
                      borderRadius: '5px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    }}
                  >
                    {titleDef.ribbonUrl ? (
                      <img
                        src={titleDef.ribbonUrl}
                        alt={`${titleDef.name || 'Title'} Ribbon`}
                        style={{
                          width: '200px',
                          height: 'auto',
                          marginBottom: '10px',
                          objectFit: 'contain',
                        }}
                        onError={(e) => (e.target.src = '/images/fallback-ribbon.png')}
                      />
                    ) : (
                      <span
                        style={{
                          width: '200px',
                          height: '100px',
                          display: 'block',
                          marginBottom: '10px',
                          backgroundColor: '#ccc',
                          lineHeight: '100px',
                          color: '#888',
                          fontSize: '20px',
                        }}
                      >
                        —
                      </span>
                    )}
                    <div>
                      <p style={{ margin: '5px 0', fontSize: '16px' }}>
                        <strong style={{ color: '#333' }}>{titleDef.name || 'Unknown Title'}</strong>
                        {displayPrefix && (
                          <span style={{ fontWeight: 'bold', color: '#4CAF50' }}> {displayPrefix}</span>
                        )}
                      </p>
                      <p style={{ margin: '5px 0', fontSize: '14px', color: '#555' }}>
                        Earned: {new Date(title.dateEarned).toLocaleDateString()}
                      </p>
                      {title.artworkUrl && (
                        <p style={{ margin: '5px 0', fontSize: '14px' }}>
                          <a
                            href={title.artworkUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#4CAF50', textDecoration: 'none' }}
                            onMouseOver={e => (e.target.style.textDecoration = 'underline')}
                            onMouseOut={e => (e.target.style.textDecoration = 'none')}
                          >
                            View Proof
                          </a>
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p style={{ color: '#888', fontSize: '16px', textAlign: 'center' }}>
              No titles match the current filters.
            </p>
          )}
        </div>
      )}
{showAffiliateForm && (
  <div style={{ position: 'fixed', top: '20%', left: '50%', transform: 'translateX(-50%)', background: '#fff', padding: '20px', border: '1px solid #d9ead3', zIndex: '800', boxShadow: '0 2px 10px rgba(0,0,0,0.2)', width: '350px', borderRadius: '8px' }}>
    <h3>Record Affiliate Club Title</h3>
    <form onSubmit={async (e) => {
      e.preventDefault();
      try {
        const res = await fetch(`${API_BASE_URL}/dog/${dog.dogId}/affiliate-title`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
          body: JSON.stringify({ playerId, titleName: affiliateFormData.titleName, proofLink: affiliateFormData.proofLink }),
        });
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        setDog(data.dog);
        setMessage('Affiliate Club Title recorded!');
        setShowAffiliateForm(false);
      } catch (err) {
        setMessage('Failed: ' + err.message);
      }
    }}>
      <input type="text" placeholder="Title Name (e.g. UKC Grand Champion)" value={affiliateFormData.titleName} onChange={e => setAffiliateFormData({ ...affiliateFormData, titleName: e.target.value })} style={{ display: 'block', width: '100%', marginBottom: '10px', padding: '5px' }} required />
      <input type="url" placeholder="Proof Link (DeviantArt or club page)" value={affiliateFormData.proofLink} onChange={e => setAffiliateFormData({ ...affiliateFormData, proofLink: e.target.value })} style={{ display: 'block', width: '100%', marginBottom: '10px', padding: '5px' }} required />
      <button type="submit" style={{ backgroundColor: '#4CAF50', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '5px', marginRight: '10px' }}>Save Title</button>
      <button type="button" onClick={() => setShowAffiliateForm(false)} style={{ padding: '8px 16px', backgroundColor: '#d9ead3', border: '1px solid #ccc', borderRadius: '5px' }}>Cancel</button>
    </form>
  </div>
)}

{/* ==================== AFFILIATE CLUB TITLES ==================== */}
<h2
  style={{
    cursor: 'pointer',
    color: collapsed.affiliate ? '#555' : '#4CAF50',
    marginBottom: '20px',
    transition: 'color 0.3s',
  }}
  onClick={() => toggleCollapse('affiliate')}
>
  Affiliate Club Titles {collapsed.affiliate ? '▲' : '▼'}
</h2>
{!collapsed.affiliate && (
  <div style={{ backgroundColor: '#f9f9f9', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', border: '1px solid #d9ead3' }}>
    {playerId === dog.playerId && (
      <button
        onClick={() => setShowAffiliateForm(true)}
        style={{ marginBottom: '15px', padding: '8px 16px', backgroundColor: '#b6d7a8', color: '#38761d', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
      >
        + Record New Affiliate Club Title
      </button>
    )}

    {dog.affiliateClubTitles && dog.affiliateClubTitles.length > 0 ? (
      <table style={{ width: '100%', maxWidth: '760px', borderCollapse: 'collapse', margin: '0 auto' }}>
        <thead>
          <tr style={{ background: '#f0f0f0' }}>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Title Name</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Proof Link</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Date</th>
            <th style={{ border: '1px solid #ccc', padding: '8px', width: '80px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {dog.affiliateClubTitles.map((t, i) => (
            <tr key={i}>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{t.titleName}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                <a href={t.proofLink} target="_blank" rel="noopener noreferrer" style={{ color: '#1E88E5' }}>
                  View Proof
                </a>
              </td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                {new Date(t.dateEarned).toLocaleDateString()}
              </td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                {playerId === dog.playerId && (
                  <button
                    onClick={() => {
                      if (window.confirm('Delete this affiliate title permanently?')) {
                        fetch(`${API_BASE_URL}/dog/${dog.dogId}/affiliate-title/${i}`, {
                          method: 'DELETE',
                          headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${localStorage.getItem('token')}`,
                          },
                          body: JSON.stringify({ playerId }),
                        })
                          .then(res => res.json())
                          .then(data => {
                            setDog(data.dog);
                            setMessage('Affiliate title deleted');
                          })
                          .catch(err => setMessage('Delete failed: ' + err.message));
                      }
                    }}
                    style={{ backgroundColor: '#ff4d4d', color: 'white', padding: '4px 10px', border: 'none', borderRadius: '3px', cursor: 'pointer', fontSize: '12px' }}
                  >
                    Delete
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    ) : (
      <p style={{ color: '#888', textAlign: 'center' }}>No affiliate club titles recorded yet.</p>
    )}
  </div>
)}
      <h2
        style={{
          cursor: 'pointer',
          color: collapsed.showRecord ? '#555' : '#4CAF50',
          marginBottom: '20px',
          transition: 'color 0.3s',
        }}
        onClick={() => toggleCollapse('showRecord')}
      >
        Show Record {collapsed.showRecord ? '▲' : '▼'}
      </h2>
      {!collapsed.showRecord && (
        <div
          style={{
            backgroundColor: '#f9f9f9',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            border: '1px solid #d9ead3',
            width: '100%',
            maxWidth: '1200px',
            margin: '0 auto',
  }}
>
          <p style={{ fontWeight: 'bold', color: '#4CAF50', marginBottom: '20px' }}>
            Total Award Points Earned (All Types): {
              (dog.showRecords?.reduce((sum, r) => sum + (r.validated ? r.awardPoints || 0 : 0), 0) || 0) +
              (dog.sportingRecords?.reduce((sum, r) => sum + (r.validated ? r.awardPoints || 0 : 0), 0) || 0)
            }
          </p>

          <div>
            <h3 style={{ color: '#0b5394', marginBottom: '10px' }}>Conformation Records</h3>
            <p style={{ fontWeight: 'bold', color: '#4CAF50', marginBottom: '5px' }}>
              Total Award Points (Conformation): {dog.showRecords?.reduce((sum, r) => sum + (r.awardPoints || 0), 0) || 0}
            </p>
            <p style={{ fontWeight: 'bold', color: '#4CAF50', marginBottom: '10px' }}>
              Validated Award Points (Conformation): {dog.showRecords?.reduce((sum, r) => sum + (r.validated ? r.awardPoints || 0 : 0), 0) || 0}
            </p>
            {playerId === dog.playerId && (
              <div style={{ marginBottom: '10px' }}>
                <button
                  onClick={() => addCustomShowRecord('conformation')}
                  style={{
                    marginRight: '10px',
                    padding: '5px 10px',
                    backgroundColor: '#b6d7a8',
                    color: '#38761d',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  Add Custom Conformation Record
                </button>
                <button
                  onClick={() => setShowAllConformation(true)}
                  style={{
                    padding: '5px 10px',
                    backgroundColor: showAllConformation ? '#d9ead3' : '#b6d7a8',
                    color: showAllConformation ? '#333' : '#38761d',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  {showAllConformation ? 'Paginate' : 'Show All'}
                </button>
              </div>
            )}
            {dog.showRecords && dog.showRecords.length > 0 ? (
              <>
                <table
                  style={{
                    width: '100%',
                    maxWidth: '760px',
                    borderCollapse: 'collapse',
                    margin: '20px auto',
                  }}
                >
                  <thead>
                    <tr style={{ background: '#f0f0f0' }}>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '80px', width: '15%' }}>Date</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '120px', width: '20%' }}>Show Name / Entry</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '70px', width: '15%' }}>Results</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '60px', width: '10%' }}>Points</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '80px', width: '15%' }}>Source</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '50px', width: '10%' }}>Verified</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '120px', width: '15%' }}>Ribbons</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(showAllConformation ? dog.showRecords : getPaginatedRecords(dog.showRecords, conformationPage)).map((record, idx) => (
                      <tr key={idx}>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{new Date(record.date).toLocaleDateString()}</td>
                        <td style={{ border: '1px solid #ccc', padding: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <span style={{ marginBottom: '5px', textAlign: 'center' }}>{record.showName}</span>
                          {record.artworkLink ? (
                            <a href={record.artworkLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                              <button style={{ backgroundColor: '#9fc5e8', color: 'white', padding: '3px 8px', border: 'none', borderRadius: '3px', cursor: 'pointer', fontSize: '11px', fontWeight: 'bold' }}>
                                Entry
                              </button>
                            </a>
                          ) : (
                            <span style={{ color: '#888', fontSize: '11px' }}>-</span>
                          )}
                        </td>
                        <td style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'center' }}>
                          <button onClick={() => setSelectedRecord(record)} style={{ backgroundColor: '#4CAF50', color: 'white', padding: '5px 10px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '12px' }}>
                            View Show Results
                          </button>
                        </td>
                        <td style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'center' }}>{record.awardPoints || 0}</td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{record.source}</td>
                        <td style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'center' }}>
                          {record.validated ? <span style={{ color: 'blue', fontSize: '20px' }}>✓</span> : <span style={{ color: 'red', fontSize: '20px' }}>✗</span>}
                        </td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                          {record.iconUrl && Array.isArray(record.iconUrl) ? (
                            record.iconUrl.map((url, i) => (
                              <img key={i} src={url} alt="Ribbon" style={{ width: '50px', height: 'auto', marginRight: '5px' }} />
                            ))
                          ) : record.iconUrl ? (
                            <img src={record.iconUrl} alt="Ribbon" style={{ width: '50px', height: 'auto' }} />
                          ) : '-'}
                          {record.source === 'Player' && playerId === dog.playerId && !record.validated && (
                            <button
                              onClick={() => editCustomShowRecord(record, 'conformation')}
                              style={{ marginLeft: '10px', padding: '2px 5px', fontSize: '12px', backgroundColor: '#d9ead3', color: '#333', border: '1px solid #ccc', borderRadius: '3px', cursor: 'pointer' }}
                              onMouseOver={e => e.target.style.backgroundColor = '#c8d9c2'}
                              onMouseOut={e => e.target.style.backgroundColor = '#d9ead3'}
                            >
                              Edit
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {renderPagination(conformationPage, totalConformationPages, setConformationPage, showAllConformation, setShowAllConformation)}
              </>
            ) : (
              <p style={{ color: '#888', fontSize: '16px', textAlign: 'center' }}>No conformation records yet.</p>
            )}
          </div>

          <div>
            <h3 style={{ color: '#0b5394', marginTop: '30px', marginBottom: '10px' }}>Sporting Records</h3>
            <p style={{ fontWeight: 'bold', color: '#4CAF50', marginBottom: '5px' }}>
              Total Award Points (Sporting): {dog.sportingRecords?.reduce((sum, r) => sum + (r.awardPoints || 0), 0) || 0}
            </p>
            <p style={{ fontWeight: 'bold', color: '#4CAF50', marginBottom: '5px' }}>
              Validated Award Points (Sporting): {dog.sportingRecords?.reduce((sum, r) => sum + (r.validated ? r.awardPoints || 0 : 0), 0) || 0}
            </p>
            <p style={{ fontWeight: 'bold', color: '#4CAF50', marginBottom: '5px' }}>
              Total Validated Qualifying Scores: {dog.totalQualifyingScores || 0}
            </p>
            <p style={{ fontWeight: 'bold', color: '#4CAF50', marginBottom: '10px' }}>
              Usable Qualifying Scores: {dog.totalUsableQualifyingScores || 0}
              {dog.totalQualifyingScores > dog.totalUsableQualifyingScores && (
                <span style={{ color: '#888', fontWeight: 'normal' }}> ({dog.totalQualifyingScores - dog.totalUsableQualifyingScores} claimed)</span>
              )}
            </p>
            {playerId === dog.playerId && (
              <div style={{ marginBottom: '10px' }}>
                <button
                  onClick={() => addCustomShowRecord('sporting')}
                  style={{
                    marginRight: '10px',
                    padding: '5px 10px',
                    backgroundColor: '#b6d7a8',
                    color: '#38761d',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  Add Custom Sporting Record
                </button>
                <button
                  onClick={() => setShowAllSporting(true)}
                  style={{
                    padding: '5px 10px',
                    backgroundColor: showAllSporting ? '#d9ead3' : '#b6d7a8',
                    color: showAllSporting ? '#333' : '#38761d',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  {showAllSporting ? 'Paginate' : 'Show All'}
                </button>
              </div>
            )}
            {dog.sportingRecords && dog.sportingRecords.length > 0 ? (
              <>
                <table
                  style={{
                    width: '100%',
                    maxWidth: '760px',
                    borderCollapse: 'collapse',
                    margin: '20px auto',
                  }}
                >
                  <thead>
                    <tr style={{ background: '#f0f0f0' }}>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '80px', width: '15%' }}>Date</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '120px', width: '20%' }}>Show Name / Entry</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '70px', width: '15%' }}>Results</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '50px', width: '10%' }}>Points</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '40px', width: '5%' }}>QS</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '80px', width: '15%' }}>Source</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '50px', width: '10%' }}>Verified</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px', minWidth: '120px', width: '15%' }}>Ribbons</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(showAllSporting ? dog.sportingRecords : getPaginatedRecords(dog.sportingRecords, sportingPage)).map((record, idx) => (
                      <tr key={idx}>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{new Date(record.date).toLocaleDateString()}</td>
                        <td style={{ border: '1px solid #ccc', padding: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <span style={{ marginBottom: '5px', textAlign: 'center' }}>{record.showName}</span>
                          {record.artworkLink ? (
                            <a href={record.artworkLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                              <button style={{ backgroundColor: '#9fc5e8', color: 'white', padding: '3px 8px', border: 'none', borderRadius: '3px', cursor: 'pointer', fontSize: '11px', fontWeight: 'bold' }}>
                                Entry
                              </button>
                            </a>
                          ) : (
                            <span style={{ color: '#888', fontSize: '11px' }}>-</span>
                          )}
                        </td>
                        <td style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'center' }}>
                          <button onClick={() => setSelectedRecord(record)} style={{ backgroundColor: '#4CAF50', color: 'white', padding: '5px 10px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '12px' }}>
                            View Show Results
                          </button>
                        </td>
                        <td style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'center' }}>{record.awardPoints || 0}</td>
                        <td style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'center' }}>
                          {record.qualifyingScore ? (
                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                              <span style={{ color: record.usable ? 'blue' : '#9fc5e8', fontSize: '20px', opacity: record.usable ? 1 : 0.5 }}>✓</span>
                              {!record.usable && <span style={{ color: '#9fc5e8', fontSize: '12px' }}>(claimed)</span>}
                            </span>
                          ) : (
                            <span style={{ color: 'red', fontSize: '20px' }}>✗</span>
                          )}
                        </td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{record.source}</td>
                        <td style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'center' }}>
                          {record.validated ? <span style={{ color: 'blue', fontSize: '20px' }}>✓</span> : <span style={{ color: 'red', fontSize: '20px' }}>✗</span>}
                        </td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                          {record.iconUrl && Array.isArray(record.iconUrl) ? (
                            record.iconUrl.map((url, i) => (
                              <img key={i} src={url} alt="Ribbon" style={{ width: '50px', height: 'auto', marginRight: '5px' }} />
                            ))
                          ) : '-'}
                          {record.source === 'Player' && playerId === dog.playerId && !record.validated && (
                            <button
                              onClick={() => editCustomShowRecord(record, 'sporting')}
                              style={{ marginLeft: '10px', padding: '2px 5px', fontSize: '12px', backgroundColor: '#d9ead3', color: '#333', border: '1px solid #ccc', borderRadius: '3px', cursor: 'pointer' }}
                              onMouseOver={e => e.target.style.backgroundColor = '#c8d9c2'}
                              onMouseOut={e => e.target.style.backgroundColor = '#d9ead3'}
                            >
                              Edit
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {renderPagination(sportingPage, totalSportingPages, setSportingPage, showAllSporting, setShowAllSporting)}
              </>
            ) : (
              <p style={{ color: '#888', fontSize: '16px', textAlign: 'center' }}>No sporting records yet.</p>
            )}
          </div>

          {selectedRecord && (
            <div
              style={{
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: '1000',
              }}
            >
              <div
                style={{
                  backgroundColor: '#fff',
                  padding: '20px',
                  borderRadius: '8px',
                  width: '500px',
                  maxHeight: '80vh',
                  overflowY: 'auto',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                  position: 'relative',
                }}
              >
                <button
                  onClick={() => setSelectedRecord(null)}
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    backgroundColor: '#ff4d4d',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '25px',
                    height: '25px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    lineHeight: '25px',
                    textAlign: 'center',
                  }}
                >
                  ✕
                </button>
                <h3 style={{ color: '#4CAF50', marginBottom: '15px' }}>Show Results</h3>
                <p><strong>Show Name:</strong> {selectedRecord.showName}</p>
                <p><strong>Result:</strong></p>
                <pre style={{ whiteSpace: 'pre-wrap', margin: '0 0 15px 0', fontSize: '14px' }}>
                  {selectedRecord.result.split('\n').map((line, i) => (
                    <div key={i}>
                      {selectedRecord.resultUrl && selectedRecord.source === 'Player' ? (
                        <a
                          href={selectedRecord.resultUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: '#4CAF50', textDecoration: 'none' }}
                          onMouseOver={e => (e.target.style.textDecoration = 'underline')}
                          onMouseOut={e => (e.target.style.textDecoration = 'none')}
                        >
                          {line}
                        </a>
                      ) : (
                        line
                      )}
                    </div>
                  ))}
                </pre>
              </div>
            </div>
          )}

          {showForm && (
            <div
              style={{
                position: 'fixed',
                top: '20%',
                left: '50%',
                transform: 'translateX(-50%)',
                background: '#fff',
                padding: '20px',
                border: '1px solid #d9ead3',
                zIndex: '800',
                boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                width: '350px',
                borderRadius: '8px',
              }}
            >
              <h3>{formData._id ? 'Edit' : 'Add'} Custom {formType === 'conformation' ? 'Conformation' : 'Sporting'} Record</h3>
              <form onSubmit={formData._id ? handleEditSubmit : handleSubmit}>
                <input
                  type="text"
                  placeholder="Show Name"
                  value={formData.showName}
                  onChange={e => setFormData({ ...formData, showName: e.target.value })}
                  style={{ display: 'block', marginBottom: '10px', width: '100%', padding: '5px', borderRadius: '3px', border: '1px solid #ccc' }}
                  required
                />
                <input
                  type="text"
                  placeholder="Result"
                  value={formData.result}
                  onChange={e => setFormData({ ...formData, result: e.target.value })}
                  style={{ display: 'block', marginBottom: '10px', width: '100%', padding: '5px', borderRadius: '3px', border: '1px solid #ccc' }}
                  required
                />
                <input
                  type="number"
                  placeholder="Earned Award Points"
                  value={formData.awardPoints}
                  onChange={e => setFormData({ ...formData, awardPoints: parseInt(e.target.value) || 0 })}
                  min="0"
                  style={{ display: 'block', marginBottom: '10px', width: '100%', padding: '5px', borderRadius: '3px', border: '1px solid #ccc' }}
                  required
                />
                {formType === 'sporting' && (
                  <label style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                    <input
                      type="checkbox"
                      checked={formData.qualifyingScore}
                      onChange={e => setFormData({ ...formData, qualifyingScore: e.target.checked })}
                      style={{ marginRight: '10px' }}
                    />
                    Qualifying Score
                  </label>
                )}
                <input
                  type="url"
                  placeholder="Ribbon Image URL (optional)"
                  value={formData.iconUrl}
                  onChange={e => setFormData({ ...formData, iconUrl: e.target.value })}
                  style={{ display: 'block', marginBottom: '10px', width: '100%', padding: '5px', borderRadius: '3px', border: '1px solid #ccc' }}
                />
                <input
                  type="url"
                  placeholder="Result Link URL (optional)"
                  value={formData.resultUrl}
                  onChange={e => setFormData({ ...formData, resultUrl: e.target.value })}
                  style={{ display: 'block', marginBottom: '10px', width: '100%', padding: '5px', borderRadius: '3px', border: '1px solid #ccc' }}
                />
                <input
                  type="url"
                  placeholder="Artwork Link URL (optional)"
                  value={formData.artworkLink}
                  onChange={e => setFormData({ ...formData, artworkLink: e.target.value })}
                  style={{ display: 'block', marginBottom: '10px', width: '100%', padding: '5px', borderRadius: '3px', border: '1px solid #ccc' }}
                />
                <button
                  type="submit"
                  style={{
                    marginRight: '10px',
                    padding: '5px 10px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  {formData._id ? 'Update' : 'Add'}
                </button>
                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  style={{
                    padding: '5px 10px',
                    backgroundColor: '#d9ead3',
                    color: '#333',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  Cancel
                </button>
              </form>
            </div>
          )}
        </div>
      )}

<h2
        style={{
          cursor: 'pointer',
          color: collapsed.health ? '#555' : '#4CAF50',
          marginBottom: '20px',
          transition: 'color 0.3s',
        }}
        onClick={() => toggleCollapse('health')}
      >
        Health Test Records {collapsed.health ? '▲' : '▼'}
      </h2>
      {!collapsed.health && (
        <div
          style={{
            backgroundColor: '#f9f9f9',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            border: '1px solid #d9ead3',
          }}
        >
          {playerId === dog?.playerId && !hasHealthTests && (
            <Link to="/health-testing">
              <button
                style={{
                  margin: '10px',
                  background: '#4CAF50',
                  color: 'white',
                  padding: '10px',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                Get Health Tests
              </button>
            </Link>
          )}
          <h3 style={{ color: '#4CAF50' }}>DFG BBP Test Results</h3>
          {dog?.healthTestRecords?.some(r => !r.testName.startsWith('Body Scores')) ? (
            <table style={{ width: '100%', maxWidth: '600px', borderCollapse: 'collapse', margin: '20px auto' }}>
              <thead>
                <tr style={{ background: '#f0f0f0' }}>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>Test</th>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>Result</th>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>Date Tested</th>
                </tr>
              </thead>
              <tbody>
                {dog.healthTestRecords
                  .filter(r => !r.testName.startsWith('Body Scores'))
                  .sort((a, b) => a.testName.localeCompare(b.testName))
                  .map((record, index) => (
                    <tr key={index}>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>{record.testName}</td>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>{record.result}</td>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                        {record.dateTested ? new Date(record.dateTested).toLocaleDateString() : 'N/A'}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: '#888', fontSize: '16px', textAlign: 'center' }}>No DFG BBP test results yet.</p>
          )}

          <h3 style={{ color: '#4CAF50' }}>DFG Body Scores</h3>
          {dog?.healthTestRecords?.some(r => r.testName.startsWith('Body Scores')) ? (
            <table style={{ width: '100%', maxWidth: '600px', borderCollapse: 'collapse', margin: '20px auto' }}>
              <thead>
                <tr style={{ background: '#f0f0f0' }}>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>Test</th>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>Score</th>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>Grade</th>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>Date Tested</th>
                </tr>
              </thead>
              <tbody>
                {dog.healthTestRecords
                  .filter(r => r.testName.startsWith('Body Scores'))
                  .sort((a, b) => a.testName.localeCompare(b.testName))
                  .map((record, index) => (
                    <tr key={index}>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>{record.testName.replace('Body Scores - ', '')}</td>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>{record.score || 'N/A'}</td>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>{record.result}</td>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                        {record.dateTested ? new Date(record.dateTested).toLocaleDateString() : 'N/A'}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: '#888', fontSize: '16px', textAlign: 'center' }}>No DFG Body Scores test results yet.</p>
          )}

          <h3 style={{ color: '#4CAF50' }}>Write-In BBP Test Results</h3>
          {dog?.customHealthTests?.some(t => t.testType === 'bbp') ? (
            <table style={{ width: '100%', maxWidth: '600px', borderCollapse: 'collapse', margin: '20px auto' }}>
              <thead>
                <tr style={{ background: '#f0f0f0' }}>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>Test</th>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>Result</th>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>External Link</th>
                </tr>
              </thead>
              <tbody>
                {dog.customHealthTests
                  .filter(t => t.testType === 'bbp')
                  .sort((a, b) => a.disease.localeCompare(b.disease))
                  .map((test, index) => (
                    <tr key={index}>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>{test.disease}</td>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>{test.result}</td>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                        <a href={test.externalLink} target="_blank" rel="noopener noreferrer" style={{ color: '#1E88E5' }}>
                          View Proof
                        </a>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: '#888', fontSize: '16px', textAlign: 'center' }}>No write-in BBP test results yet.</p>
          )}

          <h3 style={{ color: '#4CAF50' }}>Write-In Body Scores</h3>
          {dog?.customHealthTests?.some(t => t.testType === 'body') ? (
            <table style={{ width: '100%', maxWidth: '600px', borderCollapse: 'collapse', margin: '20px auto' }}>
              <thead>
                <tr style={{ background: '#f0f0f0' }}>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>Test</th>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>Result</th>
                  <th style={{ border: '1px solid #ccc', padding: '8px' }}>External Link</th>
                </tr>
              </thead>
              <tbody>
                {dog.customHealthTests
                  .filter(t => t.testType === 'body')
                  .sort((a, b) => a.disease.localeCompare(b.disease))
                  .map((test, index) => (
                    <tr key={index}>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>{test.disease}</td>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>{test.result}</td>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                        <a href={test.externalLink} target="_blank" rel="noopener noreferrer" style={{ color: '#1E88E5' }}>
                          View Proof
                        </a>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: '#888', fontSize: '16px', textAlign: 'center' }}>No write-in Body Scores test results yet.</p>
          )}
        </div>
      )}
      <h2
        style={{
          cursor: 'pointer',
          color: collapsed.pedigree ? '#555' : '#4CAF50',
          marginBottom: '20px',
          transition: 'color 0.3s',
        }}
        onClick={() => toggleCollapse('pedigree')}
      >
        Pedigree {collapsed.pedigree ? '▲' : '▼'}
      </h2>
      {!collapsed.pedigree && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '20px 0',
            backgroundColor: '#f9f9f9',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            border: '1px solid #d9ead3',
          }}
        >
          <div
            style={{
              fontFamily: 'monospace',
              textAlign: 'left',
              padding: '15px',
              width: 'fit-content',
              maxWidth: '800px',
            }}
          >
            <PedigreeEntry info={dog.sireInfo?.sireInfo?.sireInfo} label="SSS" indent={2} />
            <PedigreeEntry info={dog.sireInfo?.sireInfo} label="SS" indent={1} />
            <PedigreeEntry info={dog.sireInfo?.sireInfo?.damInfo} label="SSD" indent={2} />
            <PedigreeEntry info={dog.sireInfo} label="Sire" indent={0} />
            <PedigreeEntry info={dog.sireInfo?.damInfo?.sireInfo} label="SDS" indent={2} />
            <PedigreeEntry info={dog.sireInfo?.damInfo} label="SD" indent={1} />
            <PedigreeEntry info={dog.sireInfo?.damInfo?.damInfo} label="SDD" indent={2} />
            <PedigreeEntry info={dog.damInfo?.sireInfo?.sireInfo} label="DSS" indent={2} />
            <PedigreeEntry info={dog.damInfo?.sireInfo} label="DS" indent={1} />
            <PedigreeEntry info={dog.damInfo?.sireInfo?.damInfo} label="DSD" indent={2} />
            <PedigreeEntry info={dog.damInfo} label="Dam" indent={0} />
            <PedigreeEntry info={dog.damInfo?.damInfo?.sireInfo} label="DDS" indent={2} />
            <PedigreeEntry info={dog.damInfo?.damInfo} label="DD" indent={1} />
            <PedigreeEntry info={dog.damInfo?.damInfo?.damInfo} label="DDD" indent={2} />
          </div>
        </div>
      )}

      <h2
        style={{
          cursor: 'pointer',
          color: collapsed.offspring ? '#555' : '#4CAF50',
          marginBottom: '20px',
          transition: 'color 0.3s',
        }}
        onClick={() => toggleCollapse('offspring')}
      >
        Offspring {collapsed.offspring ? '▲' : '▼'}
      </h2>
      {!collapsed.offspring && (
        <div
          style={{
            backgroundColor: '#f9f9f9',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            border: '1px solid #d9ead3',
          }}
        >
          {dog.offspring && dog.offspring.length > 0 ? (
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              {dog.offspring.map(child => (
                <li key={child._id} style={{ margin: '10px 0' }}>
                  <Link
                    to={`/dog/${child.dogId}`}
                    style={{ color: '#4CAF50', textDecoration: 'none' }}
                    onMouseOver={e => (e.target.style.textDecoration = 'underline')}
                    onMouseOut={e => (e.target.style.textDecoration = 'none')}
                  >
                    {child.registeredName}
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <p style={{ color: '#888', fontSize: '16px', textAlign: 'center' }}>
              No offspring registered.
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default DogProfile;